const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID?.trim();

export function initializeMetaPixel() {
  if (!META_PIXEL_ID || typeof window === 'undefined' || typeof document === 'undefined') {
    return false;
  }

  if (!window.fbq) {
    const fbq = function metaPixelQueue() {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };

    window.fbq = fbq;
    window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    script.id = 'meta-pixel-script';
    document.head.appendChild(script);
  }

  if (!window.__interviewMetaPixelInitialized) {
    window.fbq('init', META_PIXEL_ID);
    window.fbq('track', 'PageView');
    window.__interviewMetaPixelInitialized = true;
  }

  return true;
}

export function trackCompletedRegistration(user) {
  if (!initializeMetaPixel() || !user?.role || user.role === 'admin') {
    return false;
  }

  const registrationKey = `meta-registration:${user.id || user.email || user.role}`;
  if (window.localStorage.getItem(registrationKey)) {
    return false;
  }

  if (user.role === 'company') {
    window.fbq('trackCustom', 'EmployerRegistration');
  } else {
    window.fbq('track', 'CompleteRegistration');
    window.fbq('trackCustom', 'JobSeekerRegistration');
  }
  window.localStorage.setItem(registrationKey, new Date().toISOString());
  return true;
}
